import React, { Component } from 'react';
import window from 'window-or-global';

import { token } from '@atlaskit/tokens';

import spaceWelcomeImage from './images/spaceWelcome.svg';

/* These overrides are to make some existing AUI styles look like ADG3 */
export default class LegacyCssOverrides extends Component {
	removeHeightAndOverflowForLegacyPage() {
		// Remove once https://product-fabric.atlassian.net/browse/CONFSIM-1635 is released
		// Proper fix has been done in the back-end velocity template
		const div = window.document.querySelector('body > div:first-of-type');
		if (div && div.style.height === '100vh') {
			div.style.height = '';
			div.style.overflow = '';
		}
	}

	render() {
		this.removeHeightAndOverflowForLegacyPage();

		return (
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
			<style>
				{`
  /* Applies to global "ADG3" font families. */
  body, body.aui-layout { font-family: ${token('font.family.body')}; }

  /* Resets the background colors to white (which were previously set to gray by AUI */
  body { background-color: ${token('elevation.surface')}; }
  div#full-height-container { background-color: ${token('elevation.surface')}; }

  body .aui-page-panel { border:none; position:inherit; margin:0; }

  /* Make the header transparent on legacy pages that contain the ADG3 sidebar. */
  body #main-header { background-color:transparent !important; }

  /* Make the secondary navigation on legacy pages look slightly nicer. This should be replaced with an Atlaskit component eventually. */
  body .aui-navgroup-horizontal { background-color: transparent; margin:0 0 24px 0; border-top:none; }
  body .aui-navgroup-horizontal .aui-nav a { color: ${token('color.text')}; }
  body .aui-navgroup-horizontal .aui-nav a:hover { background-color:transparent; text-decoration:underline; }
  body .aui-navgroup-horizontal .aui-nav > .aui-nav-selected a { border-bottom:3px solid ${token(
		'color.border.selected',
	)}; }
  body .aui-navgroup-horizontal .aui-nav > .aui-nav-selected a:before,
  body .aui-navgroup-horizontal .aui-nav > .aui-nav-selected a:after { border:none; }


  /*************************************************/
  /* Begin items for just the space welcome dialog */
  /*************************************************/
  #space-welcome-dialog .dialog-panel-body {
    background: url(${spaceWelcomeImage}) no-repeat 0px 20px;
    background-size: 450px 300px;
  }

  #space-welcome-dialog .dialog-panel-body h1 {
    color: ${token('color.text')};
    font: ${token('font.heading.medium')}
    font-weight: ${token('font.weight.regular')}
    width: 293px;
    height: 58px;
  }

  #space-welcome-dialog .dialog-panel-body .space-description {
    padding-right: 0px;
    color: ${token('color.text')};
    line-height: 20px;
    height: 200px;
    font-size: 16px;
    padding-left: 541px;
  }
  #space-welcome-dialog .dialog-panel-body .space-description li {
    padding-bottom: 5px;
  }
  /***********************************************/
  /* End items for just the space welcome dialog */
  /***********************************************/


  /*************************************************************************/
  /* Begin section common to the welcome, page create and space create     */
  /* dialogs (can't currently differentiate between create space and page) */
  /*************************************************************************/

  #create-dialog,
  #space-welcome-dialog {
    /* Consistent background color for whole dialog */
    background-color: ${token('elevation.surface')};
    /* Took common minimum padding away from other areas to create a more consistent base padding */
    padding: 24px 24px 19px 24px;
  }
  #create-dialog .dialog-title,
  #space-welcome-dialog .dialog-title {
    /* conceal the border */
    border-bottom: 0px solid ${token('color.border.inverse')};
    /* most padding of title and button panel absorbed at top level by dialog padding */
    padding: 0 0 14px 0;
  }
  #create-dialog h2.dialog-title ,
  #space-welcome-dialog h2.dialog-title {
    /* Height of actual text */
    line-height: 30px;

    /* Text styling */
    color: ${token('color.text')};
    font-size: 20px;
    font-weight: ${token('font.weight.medium')};
  }
  /*******************************************************************/
  /* End common to the welcome, page create and space create dialogs */
  /* (can't currently differentiate between create space and page)   */
  /*******************************************************************/

  /* Needed to keep z-index of inline message creation popup on text highlight above Nav v2 drawer */
  /* The transform is a trick to stop the Nav v2 scrollbar from showing up over the top of the popup (Chrome bug) */
  #com-atlassian-confluence div#inline-dialog-selection-action-panel.aui-inline-dialog {
    z-index: 200;
    transform: translateZ(0px);
  }

  .ProseMirror ol[data-node-type=decisionList] {
    list-style-type: none;
    padding-left: 0;
  }
`}
			</style>
		);
	}
}
